import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // o './styles.css' a seconda della tua struttura

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
